import { ACTION_LABEL, ROLE_LABEL, fmtDateTime } from "@/lib/format";
import { Empty } from "@/components/common";

const detailText = (d) => {
  if (!d) return "";
  return Object.entries(d)
    .map(([k, v]) => `${k}: ${typeof v === "object" && v !== null ? JSON.stringify(v) : v}`)
    .join(" · ");
};

const tone = (a) => {
  if (a.includes("gagal") || a.includes("ditolak") || a.includes("nonaktif")) return "bg-rose-100 text-rose-800";
  if (a.includes("sahkan") || a.includes("ulang") || a.startsWith("harga")) return "bg-amber-100 text-amber-800";
  return "bg-slate-100 text-slate-700";
};

export function AuditTable({ rows, showTenant }) {
  if (!rows.length) return <Empty>Belum ada aktivitas tercatat.</Empty>;
  return (
    <div className="xl-wrap max-h-[65vh]" data-testid="audit-table">
      <table className="xl">
        <thead><tr><th className="rownum">#</th><th>Waktu</th>{showTenant && <th>Perusahaan</th>}<th>Pengguna</th><th>Peran</th><th>Aktivitas</th><th>Detail</th><th>IP</th></tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id}>
              <td className="rownum">{i + 1}</td>
              <td className="font-mono text-xs">{fmtDateTime(r.ts)}</td>
              {showTenant && <td>{r.tenant_name}</td>}
              <td className="font-mono text-xs">{r.actor_username || "-"}</td>
              <td className="text-xs">{ROLE_LABEL[r.actor_role] || "-"}</td>
              <td><span className={`text-[11px] font-semibold px-2 py-0.5 rounded-sm ${tone(r.action)}`}>{ACTION_LABEL[r.action] || r.action}</span></td>
              <td className="text-xs text-slate-600 max-w-[420px] truncate" title={detailText(r.detail)}>{detailText(r.detail)}</td>
              <td className="font-mono text-[11px] text-slate-500">{r.ip}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
